export default function Filters({children, dateFilter}) {
  return (
    <div className="row">
      <div className="medium-12 columns">
        <ul className="list--analytics-filters flex--justify">
          <li className="flex align-items-center">{children}</li>
          {dateFilter}
        </ul>
      </div>
    </div>
  )
}
